module.exports = __webpack_public_path__ + "fonts/icons.74b8e851.eot";